import SweetScroll from 'sweet-scroll';

const easing = 'easeOutExpo';
const GLOBAL_HEADER_HEIGHT = 60; // global_header
const GLOBAL_HEADER_HEIGHT_FOR_SP = 50; // global_header_for_SP

export function scrollTop(y = 0, duration = 1000) {
  SweetScroll.create({ duration, easing }, window).to(y);
}

export function scrollToTarget(
  targetName: string,
  duration = 1000,
  headerHeigth = GLOBAL_HEADER_HEIGHT,
) {
  try {
    const el = document.querySelector(`[data-scroll-target="${targetName}"]`);
    if (el) {
      const margin = Number(el.getAttribute('data-scroll-margin')) || 0;
      const offset = margin - headerHeigth;

      setTimeout(() => {
        SweetScroll.create({ duration, easing }, window).toElement(el, {
          offset,
        });
      }, 0);
    }
  } catch {
    return; // pass
  }
}

export function scrollToTargetForSP(targetName: string, duration = 1000) {
  scrollToTarget(targetName, duration, GLOBAL_HEADER_HEIGHT_FOR_SP);
}
